import { FormSection } from "../../../../../components/propertyDescription/descriptionUi";
import GuaranteesSection from "../GuaranteesSection";

type Props = {
  selectedGuarantees: number[];
  onChange: (event: {
    target: { checked: boolean; value: string };
  }) => void;
};

export default function GuaranteesOnlySection({
  selectedGuarantees,
  onChange,
}: Props) {
  return (
    <FormSection
      title="Garantias"
      description="Selecione ao menos uma garantia aceita na locação."
    >
      <GuaranteesSection
        selectedGuarantees={selectedGuarantees}
        onChange={onChange}
      />
    </FormSection>
  );
}
